export default __webpack_public_path__ + "static/media/Martiyers2.a15d93ed.jpg";